import { UserSettingsTheme } from '../../types';

export const defaultUserSettings = Object.freeze({
  theme: UserSettingsTheme.light
});
